import React from "react";
import Typography from "@material-ui/core/Typography";
import Swipeable from "../../../../Fronts/Main/Swipeable";
import Grid from "@material-ui/core/Grid";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Divider from "@material-ui/core/Divider";
import {  colors, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import {
    useStylesTF, useStylesLbl,
    useStylesAutoSafe,
} from '../../../../St/Reports/UseStyle';
import { GetItemFromOptions } from "../../../../services/global-services";
import moment from "moment";
import { reFormatDate } from "../../../../utils/utils";
import { permOthers } from "../checksPermmision";
import CheckboxItems, { useStylesAccs } from "../CheckBoxComponents";

export default function OthersSettings(props) {
    const { onChange, object, AutoOptions } = props;
    const levelsTypes = [
        { id: 0, name: "عام" },
        { id: 1, name: "حسب المستوى" },
        { id: 2, name: "حسب المستوى والفرع" },
    ];
    const costCenterType = [
        { id: 0, name: "اختياري" },
        { id: 1, name: "اجباري" },
    ];
    const classes = useStylesAccs();
    const clasTF = useStylesTF();
    const clasASafe = useStylesAutoSafe();
    const claslbl = useStylesLbl();
    const valueType = GetItemFromOptions(object?.prices_levels_type ?? 0, levelsTypes);
    const valueCost = GetItemFromOptions(object?.use_cost_center ?? 0, costCenterType);
    const valuebranch = GetItemFromOptions(object?.branch ?? 1, AutoOptions.Branches ?? []);

    return (
        <div className={classes.root}>
            <Accordion expanded={true}>
                <AccordionDetails className={classes.subTitle}>
                    {" "}
                </AccordionDetails>
                <Grid container lg={12} md={12} sm={12} xs={12} style={{ padding: 5 }} spacing={1}>

                    <Grid item lg={2} md={2} sm={5} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                        <TextField fullWidth variant="outlined" size="small"
                            id="No_Digit_Round"
                            label={"عدد خانات الفواصل العشرية"}
                            type="number"
                            className={clasTF.rootCust}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            name="No_Digit_Round"
                            value={object.No_Digit_Round}
                            onChange={(event, newValue) => {
                                onChange(null, {
                                    name: "No_Digit_Round",
                                    value: event.target.value,
                                });
                            }}
                        />
                    </Grid>
                    <Grid item lg={2} md={2} sm={5} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                        <TextField fullWidth variant="outlined" size="small"
                            id="Max_Item_Qty"
                            label={"كمية الصنف المسوح بها"}
                            type="number"
                            className={clasTF.rootCust}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            name="Max_Item_Qty"
                            value={object.Max_Item_Qty}
                            onChange={(event, newValue) => {
                                onChange(null, {
                                    name: "Max_Item_Qty",
                                    value: event.target.value,
                                });
                            }}
                        />
                    </Grid>
                    <Grid item lg={2} md={2} sm={5} xs={6} style={{ fontWeight: "bold", paddingBottom: "0.5rem" }}>
                        <TextField fullWidth variant="outlined" size="small"
                            id="Max_Item_Total"
                            label={"سعر الصنف المسوح به"}
                            type="number"
                            className={clasTF.rootCust}
                            InputLabelProps={{ className: claslbl.clrBlackLblS }}
                            name="Max_Item_Total"
                            value={object.Max_Item_Total}
                            onChange={(event, newValue) => {
                                onChange(null, {
                                    name: "Max_Item_Total",
                                    value: event.target.value,
                                });
                            }}
                        />
                    </Grid>
                    <Grid item xs={3} lg={3} md={4} sm={6}>
                        <Autocomplete
                            value={valueType}
                            onChange={(event, newValue) => {
                                onChange(null, {
                                    name: "prices_levels_type",
                                    value: newValue?.id,
                                });
                            }}
                            id="prices_levels_type"
                            size="small"
                            options={levelsTypes}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            style={{}}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    InputLabelProps={{ shrink: true }}
                                    label="تسعيرات الاصناف"
                                    variant="outlined"
                                />
                            )}
                        />
                    </Grid>
                    <Grid item xs={3} lg={3} md={4} sm={6}>
                        <Autocomplete
                            value={valueCost}
                            onChange={(event, newValue) => {
                                onChange(null, {
                                    name: "use_cost_center",
                                    value: newValue?.id,
                                });
                            }}
                            id="prices_levels_type"
                            size="small"
                            options={costCenterType}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option.name
                            }
                            style={{}}
                            disableClearable
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    InputLabelProps={{ shrink: true }}
                                    label="استخدام مراكز التكلفه"
                                    variant="outlined"
                                />
                            )}
                        />
                    </Grid>
                </Grid>
                <AccordionDetails >
                    <Grid item container spacing={1}>
                        {permOthers
                            ?.filter((d) => d.visible)
                            ?.map((item) => {
                                return (
                                    <Grid xs={6}>
                                        <CheckboxItems
                                            value={object[item.name] ?? null}
                                            name={item.name}
                                            label={item.label}
                                            onChange={onChange}
                                        />
                                    </Grid>
                                );
                            })}
                    </Grid>
                </AccordionDetails>

                <AccordionDetails>
                </AccordionDetails>

                <AccordionDetails style={{ backgroundColor: colors.grey[50] }}>

                    {object?.use_lock_date ?
                        (
                            <Grid container style={{ padding: 5 }} spacing={1}>

                                <Grid item lg={2} md={2} sm={4} xs={6} style={{ paddingBottom: "0.5rem" }}>
                                    <TextField fullWidth variant="outlined" size="small" id="Start_Lock_Date"
                                        label="من تاريخ"
                                        className={clasTF.rootSafe}
                                        InputProps={{ className: claslbl.clrBlackTxt }}
                                        type="date" format="YYYY-MM-DD"
                                        name="Start_Lock_Date"
                                        value={object?.Start_Lock_Date ?? moment("1999-01-01").format("YYYY-MM-DD")}
                                        //onChange={onChange('Start_Lock_Date')}
                                        onChange={(event, newValue) => {
                                            onChange(null, {
                                                name: "Start_Lock_Date",
                                                value: event.target.value,
                                            });
                                        }}
                                    /></Grid>

                                <Grid item lg={2} md={2} sm={4} xs={6} style={{ paddingBottom: "0.5rem" }}>
                                    <TextField fullWidth variant="outlined" size="small"
                                        id="End_Lock_Date" label="إلى تاريخ"
                                        className={clasTF.rootSafe}
                                        InputProps={{ className: claslbl.clrBlackTxt }}
                                        type="date" format="YYYY-MM-DD"
                                        name="End_Lock_Date" value={object?.End_Lock_Date ?? moment("1999-01-01").format("YYYY-MM-DD")}
                                        //onChange={onChange('End_Lock_Date')}
                                        onChange={(event, newValue) => {
                                            onChange(null, {
                                                name: "End_Lock_Date",
                                                value: event.target.value,
                                            });
                                        }}
                                    /></Grid>
                                <Grid item xs={2} lg={4} md={4} sm={12}>
                                    <Autocomplete
                                        value={valuebranch}
                                        onChange={(event, newValue) => {
                                            onChange(null, {
                                                name: "branch",
                                                value: newValue,
                                            });
                                            onChange(null, {
                                                name: "End_Lock_Date",
                                                value: reFormatDate(valuebranch.End_Lock_Date ?? "1999-01-01"),
                                            });
                                            onChange(null, {
                                                name: "Start_Lock_Date",
                                                value: reFormatDate(valuebranch.Start_Lock_Date ?? "1999-01-01"),
                                            });
                                        }}
                                        id="apply_discount"
                                        size="small"
                                        options={AutoOptions.Branches}
                                        getOptionLabel={(option) =>
                                            typeof option === "string" ? option : option.name
                                        }
                                        style={{}}
                                        disableClearable
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                InputLabelProps={{ shrink: true }}
                                                label="الفرع"
                                                variant="outlined"
                                            />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        ) :
                        <Typography variant="h5" style={{ textAlign: "center" }}>
                            {"\n تاكد من تفعيل خيار تفعيل اقفال الفترات الضريبية  حتى يتم عرض الخيارات"}
                        </Typography>}
                </AccordionDetails>
                <Divider className={classes.divider} />
            </Accordion>
            <Swipeable />
        </div>
    );
}
